/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Website API
 * The backend API for the website SPA
 * OpenAPI spec version: v1
 */
import {
  useQuery
} from '@tanstack/react-query'
import type {
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import * as axios from 'axios';
import type {
  AxiosError,
  AxiosRequestConfig,
  AxiosResponse
} from 'axios'
import type {
  BrandListResponse,
  GetBrandsParams,
  SegmentationId
} from './data.schemas'




export const getBrands = (
    segmentationId: SegmentationId,
    params?: GetBrandsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<BrandListResponse>> => {
    
    return axios.default.get(
      `/api/segment/${encodeURIComponent(String(segmentationId))}/brands`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getGetBrandsQueryKey = (segmentationId: SegmentationId,
    params?: GetBrandsParams,) => {
    return [`/api/segment/${segmentationId}/brands`, ...(params ? [params]: [])] as const;
    }

    
export const getGetBrandsQueryOptions = <TData = Awaited<ReturnType<typeof getBrands>>, TError = AxiosError<unknown>>(segmentationId: SegmentationId,
    params?: GetBrandsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrands>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBrandsQueryKey(segmentationId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBrands>>> = ({ signal }) => getBrands(segmentationId,params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(segmentationId),  staleTime: 900000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBrands>>, TError, TData> & { queryKey: QueryKey }
}

export type GetBrandsQueryResult = NonNullable<Awaited<ReturnType<typeof getBrands>>>
export type GetBrandsQueryError = AxiosError<unknown>

export const useGetBrands = <TData = Awaited<ReturnType<typeof getBrands>>, TError = AxiosError<unknown>>(
 segmentationId: SegmentationId,
    params?: GetBrandsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrands>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetBrandsQueryOptions(segmentationId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

export const prefetchGetBrands = async <TData = Awaited<ReturnType<typeof getBrands>>, TError = AxiosError<unknown>>(
 queryClient: QueryClient, segmentationId: SegmentationId,
    params?: GetBrandsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrands>>, TError, TData>>, axios?: AxiosRequestConfig}

  ): Promise<QueryClient> => {

  const queryOptions = getGetBrandsQueryOptions(segmentationId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}


